const ENV = {
  mapboxKey() {
    return "pk.eyJ1IjoiaHVuZHJlZC1vcmciLCJhIjoiY212ajhnMjlqMGFjcDJ4c2NtdHA0MHUxZCJ9.v7mDaGHbqkhKHPmNnRyF7g";
  }
};

export default ENV;